<div class="container">
  <div class="fuentes_all">
    <div
      style="max-height: 118px; max-width: 266px"
      class="box_fuente"
      *ngFor="let page of pages"
    >
      <a
        [routerLink]="['/noticias/']"
        [queryParams]="{ pages: page.id }"
        class="readmore boton"
        ><img [src]="page.cover"
      /></a>
    </div>
  </div>
</div>
